
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as BasePagecxOjDjTkHerYwVDNnelS9KkJ_ENIC2OFz_j8BjRnQIgMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/home/BasePage.vue?macro=true";
import { default as homednjqSCf20jvqw47Cb2GaOcCs0Pxz2q46r1JNko2xDlAMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/home.vue?macro=true";
import { default as orderpEaHXMPjxQzhbbFA6DKv1B4ufsRjSiSkwkrBmLqWAAIMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/order.vue?macro=true";
import { default as lifeCATBvRy8dAPqq1ZSHKrkj5RK0Ig2UMoD9VPbGdr7dHEMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/life.vue?macro=true";
import { default as album8XcYOAklMY5eU8e0dQO11VVYT1XNy5ghVB54waZYHkAMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/album.vue?macro=true";
import { default as indexTz0M9IEejBofebn5hMpD7zbkISLehX87Mf31rp6g8jYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/index.vue?macro=true";
import { default as story3O1Tr3RTdoz83mOSpLPAMXw8fxW5lgfnNFvedUNL0fUMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/story.vue?macro=true";
import { default as _91id_93uQyEdHRv7tycG_bigVhq3rlPnGRuoBmBOQGX4LJ4EwcMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id].vue?macro=true";
import { default as charityJK58aO0MnKfmi3FxX0ZEdJLFHpe_oi1pdzThqkXXynkMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/charity.vue?macro=true";
import { default as lanternrWig2JGjA0EQssTwxljYFxSbjey1zHHoGPdcjnVGAOEMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/lantern.vue?macro=true";
import { default as profiley6Meu1TW2V6TC1BVcdXfzrsfXIhP8Swf8KFmq74a9mMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/profile.vue?macro=true";
import { default as addPhotoEXjTrhTPJMKs1_ynVGP_PX4ODn9_CkGur9d8ZiNRTK0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addPhoto.vue?macro=true";
import { default as indexWltds3Ex27fV1e4fjmjVjgoE_E214e_1sWZ128_maykMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/me/index.vue?macro=true";
import { default as registerJ4rRWA5wbw2GgEGGNhCHxUXXAGpDfYlNB1tfSU87eVkMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/register.vue?macro=true";
import { default as fireworksvnpS1h0ofZr03W_7pqv87m_ZwYk2dIwW3FtC3mMxXroMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/fireworks.vue?macro=true";
import { default as _91id_93aAefjVr8znd6_QjbRIPFg_mHRO_Y8j935DigesDYPbsMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/[id].vue?macro=true";
import { default as listcwLKSG7saxe3EB44JgKoxgpKGhNLfWnm29Wb_3E5V2AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/list.vue?macro=true";
import { default as openLhHztXdwUqONsy0eGvRChjjYitv3QqjSe0oBRITFa_kMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/open.vue?macro=true";
import { default as _91id_93T_Xk5nuH0vk8FlXoIum7z7bhIk2RGeJ6PMQTZcLKJV4Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/altar/[id].vue?macro=true";
import { default as trade0aTHC6N1_OF1V0da9ABJGKrHdu9WrbX_L_afjazPyjsMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/coin/trade.vue?macro=true";
import { default as indexOEFK4GaeOICqQGtiHYD80HjkxjbahBghgv9orVgR3I8Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/crop/index.vue?macro=true";
import { default as indexW9zytGOPFZV6exn4b2GtMKTeu3rt7oMfj8Cyr6jpMzYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/index.vue?macro=true";
import { default as _91id_931d7SNH2nVk1GzvDX4W7Joqm7oG_GGwKH6Cd8Q4_hpq8Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/sayto/[id].vue?macro=true";
import { default as indexwHQd4Zo0i6KqOPrqWxq7F05bW1eZpAZnC_r12bXx74IMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/index.vue?macro=true";
import { default as indexr79jRVR8t34aVSUBxlRPt0tCjmTf68ExnClfAJTzonMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/about/index.vue?macro=true";
import { default as addMemorizehALOz4NcJ_9cnjBf334G73bmhGdoZVprhhW897EaZxYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addMemorize.vue?macro=true";
import { default as addOnesLifeHqVLUOBbXwKfflQ0x5zva8Sp7r2beitmdOFAQ_Grc1AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addOnesLife.vue?macro=true";
import { default as mym87uqDAMWqmkZV4yHKFgX3Wi8wUTHbXFM_dJyIoDCLcMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/articles/my.vue?macro=true";
import { default as indexqYVynwVo7vV7ccI20kcdI_IWhKgmN3Q9538aoudbfaYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/clear/index.vue?macro=true";
import { default as setRealnamemXnSC6gDAxmJ24Qr2UKd_X7malH2PpqYCvjbpJiX9ukMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/setRealname.vue?macro=true";
import { default as subappLoginyVXmWuTHWDeBBQJUUJ9vlc28qJ3xzFV7KjZdbD9fq8gMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/subappLogin.vue?macro=true";
import { default as wechatLoginP4AcwQrpgwDPxqwqRhuI2bGGFpYpzTxDsNejWTOhE1YMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/wechatLogin.vue?macro=true";
import { default as NotFoundCvzJ6RmBugHpgJgoDkp2GuWS5b43wP7U73vKlu8je9AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/404/NotFound.vue?macro=true";
import { default as _91id_93fL4wifhbiQUNXsLnh97JyCRUBbjqdZGo7SA6Rk1TuvoMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/article/[id].vue?macro=true";
import { default as archivesVrvPX4SHzsrdFEI2VSQSd2f9mebVuDvWLP9C5ieT3QMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/archive.vue?macro=true";
import { default as historyEH7aqJ6qHFronxInH8EtfIs9tlk1dNWbyv_XqlMjUisMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/history.vue?macro=true";
import { default as index9PBucshtfMg2fl25OrLzsARteh_n77tBs70CbzhB3o4Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/member/index.vue?macro=true";
import { default as indexKjqCW99_Cpfw1upbZ9C0g2IwxTqRnjTAhjpN2gyKdlIMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList/index.vue?macro=true";
import { default as openObituary1YD6Nb4F4sJld1cjYxbubZFRw3qtWKVZhKvNqc5zKSYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList/openObituary.vue?macro=true";
import { default as obituaryListTYgH9M_bd6c4oQ9YsH35p1IOpK1xH5zYsgZbEA4qPugMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList.vue?macro=true";
import { default as indexFAqUNYpM3pKKI7G5IFDLO6q_UzX50tdWtWfPxdeBDN0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/wallet/index.vue?macro=true";
import { default as deleteAccountTDGNMoizRVapwaoqCthT9q6nCMxKoHEBP2kpgOl4GBkMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/deleteAccount.vue?macro=true";
import { default as _91id_93qX7J2bsuFQkdRiMfW0NbjvQwWd8mTaSEJMux4PD_MjgMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituary/[id].vue?macro=true";
import { default as facehoHW108pn_bRTOqN763vx4SBN8OzGqoB9yKtyuE2nm0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/face.vue?macro=true";
import { default as indexKMZomtjYSehbJ7JU3sw6qjB50RiJgS4H6xuwPlKsjvMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/articles/index.vue?macro=true";
import { default as createMArticle1_tHv7dAbYyIjKs79oMIjG0P60_8_W5sVVPzhJgSk_wMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createMArticle.vue?macro=true";
import { default as editGlEamXfwyEfSXjjkDcd02tDEO_H7f24OfXP6KbLYI_MMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/edit.vue?macro=true";
import { default as indexNcthVlJcmY03tuXjWbE9I_UB7W0jQtTwPl_pQH_DLw8Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/index.vue?macro=true";
import { default as funeralDW0iokLxALEgeaiBQJJLnwNvhbnAQ_AqV9fxvfRv_wMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/funeral.vue?macro=true";
import { default as previewpT9_VCfvDTYKFEEa7EDLIgo2Skx_ZOT3bj2V9Wns_AAMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/preview.vue?macro=true";
import { default as createObituarycD4lBgcysG2M_759UmBXBdh3V79Arf2AB4oCGxGVOGkMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary.vue?macro=true";
import { default as forgetPasswordUVNA5KVjclT5uXLOXigWBLGoYXS2f6x_rNGAlAIy5zYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/forgetPassword.vue?macro=true";
import { default as _91_91type_93_93BNDjG_NoRc0_Ab5s24_PHO2hNo1i6rOrZj7ebEqDAq4Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/login/[[type]].vue?macro=true";
import { default as indexXjSdc9N__d6eobp0vGL2KZN59Sjc1V5Wn3pxET72CskMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/index.vue?macro=true";
import { default as tasksuJbHFWmgppNz4zg8c8CRAMlpiomwhexSIidbhCooQ_4Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/tasks.vue?macro=true";
import { default as indexfAjl3DOdo37Q_xVUNGr9oKeQbeg2llMCW48yOB9bQ_oMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/schedule/index.vue?macro=true";
import { default as indexZnxBEYsMxMX1UVExNgHSW9hIV35bjlIFgw8lgT4pgfoMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/settings/index.vue?macro=true";
import { default as uploadGwP3lGl_gVJggvfChO0Vpcp5WQK96yZbaUJ2N102GP0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/upload.vue?macro=true";
import { default as uploadAlbumFileA82yyWsDh5_6UcYdn2em2vZAjAyKvCrH_FFmZhHHELMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/uploadAlbumFile.vue?macro=true";
import { default as createLifevXB3bUpCdCX7ndQFyrAp7BLP0pI573N6J71yR6gS_ooMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createLife.vue?macro=true";
import { default as indexvk6YjJqZm9FaEhqaN7pIa0y_b0RhCi1u4P_8KSNOzM0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memberTest/index.vue?macro=true";
import { default as indexXjWRVlvNIeITtIOU8PnhlqRFfph8IGvL8kh69BPnoBoMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaries/index.vue?macro=true";
import { default as appareluE6C6XXs5_CbdhIfE6QKGStlQDmCNl9SGjkh1d76pfMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/apparel.vue?macro=true";
import { default as previewLfLpyE8Mpm5nzQ3s_8vNW3Z4dZDL8F6A0IkHl3YfkdUMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/preview.vue?macro=true";
import { default as indexW8zD3YtUlskEnuXqdv7N1K4MXqZq45_rskCS6mLZtYQMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/walletTest/index.vue?macro=true";
import { default as UserAdvicePageZOz5r1_b_ISRJUkqdVIcGsK9eqr3ZCkTP11mynh7zYoMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/me/UserAdvicePage.vue?macro=true";
import { default as showcasenhEY44eJinF8BJfyx5kM4cwk6T4mcluRcuAWnv3I_WYMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/showcase.vue?macro=true";
import { default as setOpenToPubV4hLuvdXg8_cJE_jPrxMPFz3qZYjnzUK1UHiquioI8cMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/setOpenToPub.vue?macro=true";
import { default as indexx5g1eW0ulKkdbGiRotRXQdGFQEglXkCapyIPOaOQ75oMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/notification/index.vue?macro=true";
import { default as createMemorialGuidei4ajbxM3wONM8tG_BecBzZlKbeCRDCB_lR6eK64bYkAMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createMemorialGuide.vue?macro=true";
import { default as createArticleq8CVDrpH_McMf5_AFISTLEuxUxXNLnyQQl_1mhUqe6AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createArticle.vue?macro=true";
import { default as indexti8k5SFfllmV_emc23VSIda_aLoIGyLATAAOhiWBaJcMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/open/index.vue?macro=true";
import { default as createBaseInfoMy7ULcRpcNqioPdDdtl_obXFLvQ4dnom98nSRMgnlHMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createBaseInfo.vue?macro=true";
import { default as MiniAppTestPageD0GvV_CpM21dV28wLzIQcYaC3Q_m2vX727mnKQrg5D4Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/MiniAppTestPage.vue?macro=true";
import { default as OverlayTestPageF0OUNMnhXfe9Sv4bym5V0oFYNS8pMiKKWsDQcEFAB9AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/OverlayTestPage.vue?macro=true";
import { default as ModalContainerAr_YZ4LIwT5iOYo4rairAl3OM6L_ewmoLO6ujqVrIy0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/dialog/ModalContainer.vue?macro=true";
import { default as FeedbackPageFW0NE_1IK0ckMCKmEpA6hTuOAhN0jmM8Z4fzedkEEh0Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/feedback/FeedbackPage.vue?macro=true";
import { default as LazyImageTestPageP4HN9qB5u31_X_2r_B_bhNWKpRMSMAR1CVBfR4YopRgMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/LazyImageTestPage.vue?macro=true";
import { default as ImageCropperPageF_k_DiOMSP_eOsonyfAR0iZcuQ52Tal5zStL8Z_XgQcMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/tools/ImageCropperPage.vue?macro=true";
import { default as _91nodeId_93D4Y2FQ8kprvHZ6aFkeugSKOZdNX1EW89Va5IqDhIOd8Meta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/image/[nodeId].vue?macro=true";
import { default as indexS4f5W8BXL5631ZgqPI7_U4Dx3KHozHV5oMfC9eaT4aUMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/familyName/index.vue?macro=true";
import { default as _91familyName_93tBYfr5CD_eQI5vX8nrnItCKSh1SHXRqyPqyTYm3PjjsMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/open/[familyName].vue?macro=true";
import { default as _91taskId_93FSICz_I1mgQRNFKTLPHVzDE4cyEgEIoAJq__KVpKnAEMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/download/[taskId].vue?macro=true";
import { default as _91feature_93S2JL2OsCrKZXjN6OhaJ_1v3j0JwE2JcDcx3rvDKVX1AMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/onestep/[feature].vue?macro=true";
import { default as createLifeAndBaseInfor5ESM811J1nFeH_5n1hUSeAPebZe_Ud_YKt5GnFZ_hMMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createLifeAndBaseInfo.vue?macro=true";
import { default as _91invitationCode_93L4t2yoNwJ0txXVwJzDUA9L3zcnaQ_HfqZR02PmQVefwMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/invitation/[invitationCode].vue?macro=true";
import { default as indexds5edNJp8M2inx1wfxfhWMpwPw9_R7EcAhAQz2qssvkMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/publicFigure/index.vue?macro=true";
import { default as MemorizeViewHistoryEQScjBZjltpXNmN5wVKBK46zN0Dj_QR6S03ysIrc8TgMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorize/MemorizeViewHistory.vue?macro=true";
import { default as _91nodeId_93wmj5_h5hjdR0JTCvscshXSQpRIFllpYOeL2Fs0eoKdwMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/pay/[taskId]/[nodeId].vue?macro=true";
import { default as _91familyName_93Ifzu4_yW_JLaltbvcLpJDZYNxmn5DClOCfX2Yxs7hOsMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/familyName/[familyName].vue?macro=true";
import { default as _91category_93mPyasfKigDy5gic9QjKJ8xJeFiYvRHkv5HDEBY3VvCIMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/publicFigure/[category].vue?macro=true";
import { default as component_45stubhcKWXd_qEErl4IrumDQZyNC6VYQeWjXdU_Slnp9o5_IMeta } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubhcKWXd_qEErl4IrumDQZyNC6VYQeWjXdU_Slnp9o5_I } from "/Users/guojialin/Workspace/FE/rm-vue-tailwind/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "home",
    path: "/home",
    meta: homednjqSCf20jvqw47Cb2GaOcCs0Pxz2q46r1JNko2xDlAMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/home.vue"),
    children: [
  {
    name: "home-BasePage",
    path: "BasePage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/home/BasePage.vue")
  }
]
  },
  {
    name: "order",
    path: "/order",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/order.vue")
  },
  {
    name: _91id_93uQyEdHRv7tycG_bigVhq3rlPnGRuoBmBOQGX4LJ4EwcMeta?.name,
    path: "/m/:id()",
    meta: _91id_93uQyEdHRv7tycG_bigVhq3rlPnGRuoBmBOQGX4LJ4EwcMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id].vue"),
    children: [
  {
    name: "m-id-life",
    path: "life",
    meta: lifeCATBvRy8dAPqq1ZSHKrkj5RK0Ig2UMoD9VPbGdr7dHEMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/life.vue")
  },
  {
    name: "m-id-album",
    path: "album",
    meta: album8XcYOAklMY5eU8e0dQO11VVYT1XNy5ghVB54waZYHkAMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/album.vue")
  },
  {
    name: "m-id",
    path: "",
    meta: indexTz0M9IEejBofebn5hMpD7zbkISLehX87Mf31rp6g8jYMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/index.vue")
  },
  {
    name: "m-id-story",
    path: "story",
    meta: story3O1Tr3RTdoz83mOSpLPAMXw8fxW5lgfnNFvedUNL0fUMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/m/[id]/story.vue")
  }
]
  },
  {
    name: "charity",
    path: "/charity",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/charity.vue")
  },
  {
    name: "lantern",
    path: "/lantern",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/lantern.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profiley6Meu1TW2V6TC1BVcdXfzrsfXIhP8Swf8KFmq74a9mMMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/profile.vue")
  },
  {
    name: "addPhoto",
    path: "/addPhoto",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addPhoto.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: indexWltds3Ex27fV1e4fjmjVjgoE_E214e_1sWZ128_maykMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/me/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerJ4rRWA5wbw2GgEGGNhCHxUXXAGpDfYlNB1tfSU87eVkMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/register.vue")
  },
  {
    name: "fireworks",
    path: "/fireworks",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/fireworks.vue")
  },
  {
    name: "life-id",
    path: "/life/:id()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/[id].vue")
  },
  {
    name: "life-list",
    path: "/life/list",
    meta: listcwLKSG7saxe3EB44JgKoxgpKGhNLfWnm29Wb_3E5V2AMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/list.vue")
  },
  {
    name: "life-open",
    path: "/life/open",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/open.vue")
  },
  {
    name: "altar-id",
    path: "/altar/:id()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/altar/[id].vue")
  },
  {
    name: "coin-trade",
    path: "/coin/trade",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/coin/trade.vue")
  },
  {
    name: "crop",
    path: "/crop",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/crop/index.vue")
  },
  {
    name: "life",
    path: "/life",
    redirect: "/life/list",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/index.vue")
  },
  {
    name: "sayto-id",
    path: "/sayto/:id()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/sayto/[id].vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/about/index.vue")
  },
  {
    name: "addMemorize",
    path: "/addMemorize",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addMemorize.vue")
  },
  {
    name: "addOnesLife",
    path: "/addOnesLife",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/addOnesLife.vue")
  },
  {
    name: "articles-my",
    path: "/articles/my",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/articles/my.vue")
  },
  {
    name: "clear",
    path: "/clear",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/clear/index.vue")
  },
  {
    name: "setRealname",
    path: "/setRealname",
    meta: setRealnamemXnSC6gDAxmJ24Qr2UKd_X7malH2PpqYCvjbpJiX9ukMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/setRealname.vue")
  },
  {
    name: "subappLogin",
    path: "/subappLogin",
    meta: subappLoginyVXmWuTHWDeBBQJUUJ9vlc28qJ3xzFV7KjZdbD9fq8gMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/subappLogin.vue")
  },
  {
    name: "wechatLogin",
    path: "/wechatLogin",
    meta: wechatLoginP4AcwQrpgwDPxqwqRhuI2bGGFpYpzTxDsNejWTOhE1YMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/wechatLogin.vue")
  },
  {
    name: "404-NotFound",
    path: "/404/NotFound",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/404/NotFound.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/article/[id].vue")
  },
  {
    name: "life-archive",
    path: "/life/archive",
    meta: archivesVrvPX4SHzsrdFEI2VSQSd2f9mebVuDvWLP9C5ieT3QMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/archive.vue")
  },
  {
    name: "life-history",
    path: "/life/history",
    meta: historyEH7aqJ6qHFronxInH8EtfIs9tlk1dNWbyv_XqlMjUisMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/life/history.vue")
  },
  {
    name: "member",
    path: "/member",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/member/index.vue")
  },
  {
    name: obituaryListTYgH9M_bd6c4oQ9YsH35p1IOpK1xH5zYsgZbEA4qPugMeta?.name,
    path: "/obituaryList",
    meta: obituaryListTYgH9M_bd6c4oQ9YsH35p1IOpK1xH5zYsgZbEA4qPugMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList.vue"),
    children: [
  {
    name: "obituaryList",
    path: "",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList/index.vue")
  },
  {
    name: "obituaryList-openObituary",
    path: "openObituary",
    meta: openObituary1YD6Nb4F4sJld1cjYxbubZFRw3qtWKVZhKvNqc5zKSYMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaryList/openObituary.vue")
  }
]
  },
  {
    name: "wallet",
    path: "/wallet",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/wallet/index.vue")
  },
  {
    name: "deleteAccount",
    path: "/deleteAccount",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/deleteAccount.vue")
  },
  {
    name: "obituary-id",
    path: "/obituary/:id()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituary/[id].vue")
  },
  {
    name: "portrait-face",
    path: "/portrait/face",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/face.vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/articles/index.vue")
  },
  {
    name: "createMArticle",
    path: "/createMArticle",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createMArticle.vue")
  },
  {
    name: createObituarycD4lBgcysG2M_759UmBXBdh3V79Arf2AB4oCGxGVOGkMeta?.name,
    path: "/createObituary",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary.vue"),
    children: [
  {
    name: "createObituary-edit",
    path: "edit",
    meta: editGlEamXfwyEfSXjjkDcd02tDEO_H7f24OfXP6KbLYI_MMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/edit.vue")
  },
  {
    name: "createObituary",
    path: "",
    meta: indexNcthVlJcmY03tuXjWbE9I_UB7W0jQtTwPl_pQH_DLw8Meta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/index.vue")
  },
  {
    name: "createObituary-funeral",
    path: "funeral",
    meta: funeralDW0iokLxALEgeaiBQJJLnwNvhbnAQ_AqV9fxvfRv_wMMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/funeral.vue")
  },
  {
    name: "createObituary-preview",
    path: "preview",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createObituary/preview.vue")
  }
]
  },
  {
    name: "forgetPassword",
    path: "/forgetPassword",
    meta: forgetPasswordUVNA5KVjclT5uXLOXigWBLGoYXS2f6x_rNGAlAIy5zYMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/forgetPassword.vue")
  },
  {
    name: "login-type",
    path: "/login/:type?",
    meta: _91_91type_93_93BNDjG_NoRc0_Ab5s24_PHO2hNo1i6rOrZj7ebEqDAq4Meta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/login/[[type]].vue")
  },
  {
    name: "portrait",
    path: "/portrait",
    meta: indexXjSdc9N__d6eobp0vGL2KZN59Sjc1V5Wn3pxET72CskMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/index.vue")
  },
  {
    name: "portrait-tasks",
    path: "/portrait/tasks",
    meta: tasksuJbHFWmgppNz4zg8c8CRAMlpiomwhexSIidbhCooQ_4Meta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/tasks.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    meta: indexfAjl3DOdo37Q_xVUNGr9oKeQbeg2llMCW48yOB9bQ_oMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/schedule/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexZnxBEYsMxMX1UVExNgHSW9hIV35bjlIFgw8lgT4pgfoMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/settings/index.vue")
  },
  {
    name: "portrait-upload",
    path: "/portrait/upload",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/upload.vue")
  },
  {
    name: "uploadAlbumFile",
    path: "/uploadAlbumFile",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/uploadAlbumFile.vue")
  },
  {
    name: "guide-createLife",
    path: "/guide/createLife",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createLife.vue")
  },
  {
    name: "memberTest",
    path: "/memberTest",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memberTest/index.vue")
  },
  {
    name: "obituaries",
    path: "/obituaries",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/obituaries/index.vue")
  },
  {
    name: "portrait-apparel",
    path: "/portrait/apparel",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/apparel.vue")
  },
  {
    name: "portrait-preview",
    path: "/portrait/preview",
    meta: previewLfLpyE8Mpm5nzQ3s_8vNW3Z4dZDL8F6A0IkHl3YfkdUMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/preview.vue")
  },
  {
    name: "walletTest",
    path: "/walletTest",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/walletTest/index.vue")
  },
  {
    name: "me-UserAdvicePage",
    path: "/me/UserAdvicePage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/me/UserAdvicePage.vue")
  },
  {
    name: "portrait-showcase",
    path: "/portrait/showcase",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/showcase.vue")
  },
  {
    name: "guide-setOpenToPub",
    path: "/guide/setOpenToPub",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/setOpenToPub.vue")
  },
  {
    name: "notification",
    path: "/notification",
    meta: indexx5g1eW0ulKkdbGiRotRXQdGFQEglXkCapyIPOaOQ75oMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/notification/index.vue")
  },
  {
    name: "createMemorialGuide",
    path: "/createMemorialGuide",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/createMemorialGuide.vue")
  },
  {
    name: "guide-createArticle",
    path: "/guide/createArticle",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createArticle.vue")
  },
  {
    name: "memorial-open",
    path: "/memorial/open",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/open/index.vue")
  },
  {
    name: "guide-createBaseInfo",
    path: "/guide/createBaseInfo",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createBaseInfo.vue")
  },
  {
    name: "test-MiniAppTestPage",
    path: "/test/MiniAppTestPage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/MiniAppTestPage.vue")
  },
  {
    name: "test-OverlayTestPage",
    path: "/test/OverlayTestPage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/OverlayTestPage.vue")
  },
  {
    name: "dialog-ModalContainer",
    path: "/dialog/ModalContainer",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/dialog/ModalContainer.vue")
  },
  {
    name: "feedback-FeedbackPage",
    path: "/feedback/FeedbackPage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/feedback/FeedbackPage.vue")
  },
  {
    name: "test-LazyImageTestPage",
    path: "/test/LazyImageTestPage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/test/LazyImageTestPage.vue")
  },
  {
    name: "tools-ImageCropperPage",
    path: "/tools/ImageCropperPage",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/tools/ImageCropperPage.vue")
  },
  {
    name: "portrait-image-nodeId",
    path: "/portrait/image/:nodeId()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/image/[nodeId].vue")
  },
  {
    name: "memorial-familyName",
    path: "/memorial/familyName",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/familyName/index.vue")
  },
  {
    name: "memorial-open-familyName",
    path: "/memorial/open/:familyName()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/open/[familyName].vue")
  },
  {
    name: "portrait-download-taskId",
    path: "/portrait/download/:taskId()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/download/[taskId].vue")
  },
  {
    name: "portrait-onestep-feature",
    path: "/portrait/onestep/:feature()",
    meta: _91feature_93S2JL2OsCrKZXjN6OhaJ_1v3j0JwE2JcDcx3rvDKVX1AMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/onestep/[feature].vue")
  },
  {
    name: "guide-createLifeAndBaseInfo",
    path: "/guide/createLifeAndBaseInfo",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/guide/createLifeAndBaseInfo.vue")
  },
  {
    name: "invitation-invitationCode",
    path: "/invitation/:invitationCode()",
    meta: _91invitationCode_93L4t2yoNwJ0txXVwJzDUA9L3zcnaQ_HfqZR02PmQVefwMeta || {},
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/invitation/[invitationCode].vue")
  },
  {
    name: "memorial-publicFigure",
    path: "/memorial/publicFigure",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/publicFigure/index.vue")
  },
  {
    name: "memorize-MemorizeViewHistory",
    path: "/memorize/MemorizeViewHistory",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorize/MemorizeViewHistory.vue")
  },
  {
    name: "portrait-pay-taskId-nodeId",
    path: "/portrait/pay/:taskId()/:nodeId()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/portrait/pay/[taskId]/[nodeId].vue")
  },
  {
    name: "memorial-familyName-familyName",
    path: "/memorial/familyName/:familyName()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/familyName/[familyName].vue")
  },
  {
    name: "memorial-publicFigure-category",
    path: "/memorial/publicFigure/:category()",
    component: () => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/pages/memorial/publicFigure/[category].vue")
  },
  {
    name: component_45stubhcKWXd_qEErl4IrumDQZyNC6VYQeWjXdU_Slnp9o5_IMeta?.name,
    path: "/",
    component: component_45stubhcKWXd_qEErl4IrumDQZyNC6VYQeWjXdU_Slnp9o5_I
  }
]